import React, { useState } from "react";
import classNames from "classnames";
import Scrollbar from "react-scrollbars-custom";

import General from './tabs/General'
import Blocks from './tabs/Blocks'

const delay = (ms) => {
  return new Promise((resolve, reject) => {
    setTimeout(resolve, ms);
  });
}

const HelpContent = () => {
  const [active, changeActive] = useState('general')
  const [fadeOut, setFadeOut] = useState(false)

  const tabClasses = (tab) => {
    return classNames({ active: active === tab });
  }

  const setActive = (tab) => {
    setFadeOut(true)
    delay(200).then(
      () => {
        setFadeOut(false)
        changeActive(tab)
      }
    )
  }

  const fadeScrollArea = () => {
    return classNames(
      'scroll-area',
      { fadeOut: fadeOut }
    )
  }

  return (
    <div className="help-content__wrapper">
      <ul className="tabs">
        <li
          onClick={() => setActive('general')}
          className={tabClasses('general')}
        >
          <a>{ i18n.t('common_questions') }</a>
        </li>
        <li
          onClick={() => setActive('blocks')}
          className={tabClasses('blocks')}
        >
          <a>{ i18n.t('blocks') }</a>
        </li>
      </ul>

      <div className={fadeScrollArea()}>
        <Scrollbar noDefaultStyles={true}>
          {active == "general" && <General />}
          {active == "blocks"  && <Blocks />}
        </Scrollbar>
      </div>
    </div>
  );
}

export default HelpContent;
